import { useState, useEffect } from "react";
import styled from "styled-components";
import { searchIllustrators } from "../../services/IllustratorService";
import { Container, Input, Dropdown, DropdownItem } from "../CommonComponents/DataCard";
import Button from "../CommonComponents/Button";

const SelectedList = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px; 
`;


const SelectedIllustrator = styled.div`
  background: ${({ theme }) => theme.colors.lineColor}33;
  color: ${({ theme }) => theme.colors.text};
  border-radius: 4px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export default function IllustratorSelector({ selectedIllustrators, setSelectedIllustrators, setShowIllustratorModal }) {
    const [query, setQuery] = useState("");
    const [illustrators, setIllustrators] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (query.length < 2) {
            setIllustrators([]);
            return;
        }

        const handler = setTimeout(async () => {
            setLoading(true);
            try {
                const results = await searchIllustrators(query);
                setIllustrators(results);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        }, 300);

        return () => clearTimeout(handler);
    }, [query]);

    const handleSelect = (illustrator) => {
        if (!selectedIllustrators.find((a) => a.id === illustrator.id)) {
            setSelectedIllustrators((prev) => [...prev, illustrator]);
        }
        setQuery("");
        setIllustrators([]);
    };

    const handleRemove = (id) => {
        setSelectedIllustrators((prev) => prev.filter((a) => a.id !== id));
    };
    return (
        <Container style={{ position: "relative", marginBottom: "3rem" }}>
            <div style={{
                display: "flex",
                flexDirection: "row",
                gap: "8px",
                alignItems: "center",
                marginBottom: "1rem"
            }}>
                <div style={{ display: "flex", gap: "8px" }}>
                    <Input
                        value={query}
                        placeholder="Pretraži ilustratora..."
                        onChange={(e) => setQuery(e.target.value)}
                        style={{ marginBottom: "0px" }}
                    />
                    <Button
                        tekst={"+"}
                        akcija={() => {
                            setShowIllustratorModal(true);
                        }}
                    />
                </div>
            </div>
            {illustrators.length > 0 && (
                <Dropdown>
                    {illustrators.map((illustrator) => (
                        <DropdownItem key={illustrator.id} onClick={() => handleSelect(illustrator)}>
                            {illustrator.name} {illustrator.surname}
                        </DropdownItem>
                    ))}
                </Dropdown>
            )}
            <h4>Odabrani ilustratori:</h4>
            <SelectedList>
                {selectedIllustrators.map((illustrator) => (
                    <SelectedIllustrator key={illustrator.id}>
                        {illustrator.name} {illustrator.surname}
                        <button onClick={() => handleRemove(illustrator.id)}>✖</button>
                    </SelectedIllustrator>
                ))}
            </SelectedList>
        </Container>
    );
}
